import { Link } from "react-router-dom"

const governoLogo = '/images/RS-logo.png';
const ppgasLogo = '/images/PPGAS.jpeg';
const uergsLogo = '/images/uergs-logo.jpeg';
const fepamLogo = '/images/fepam.jpeg';
const crvrLogo = '/images/CRVR.jpeg';
const relatorioDoc = '/Relatorio-Tecnico.pdf';

export default function Footer() {

  const handleRelatorioDownload = () => {
    // Create an anchor element
    const link = document.createElement('a');
    link.href = relatorioDoc;
    link.download = 'Relatorio-Tecnico-Estimagas.pdf'; // The name the file will be downloaded as
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
      <footer className={'w-full text-center text-sm bg-branco text-cinza-escuro pt-1 justify-center mt-8'}>
        <div className='flex flex-row justify-center'>
          <div className="mx-4">
          <p>Elaboração:</p> 
            <li>PPGAS/UERGS - Programa de Pós-Graduação em Ambiente e Sustentabilidade da Universidade Estadual do Rio Grande do Sul</li>
            <li>AsClima/SEMA - Assessoria do Clima da Secretaria do Meio Ambiente e Infraestrutura do Estado do Rio Grande do Sul</li>
            <div className="flex flex-row align-middle justify-center space-x-5">
              <img className={'h-14'} alt='Logo Governo do Estado do Rio Grande do sul'src={governoLogo} />
              <img className={'h-14'} alt='Logo PPGAS'src={ppgasLogo} />
              <img className={'h-14'} alt='Logo UERGS'src={uergsLogo} />
            </div>
          </div>
          <div className="mx-4">
          <p>Apoio:</p>
            <li>FEPAM - Fundação Estadual de Proteção Ambiental Henrique Luiz Roessler</li>
            <li>CRVR - Companhia Rio Grandense de Valorização de Resíduos</li>
            <div className="flex flex-row align-middle justify-center space-x-5">
              <img className={'h-14'} alt='FEPAM' src={fepamLogo} />
              <img className={'h-14'} alt='CRVR'src={crvrLogo} />
            </div>
          </div>
        </div>
        <div className={'w-full bg-cinza-escuro text-branco center'}>
          <div className="w-56 flex justify-between p-0 mx-auto max-h-10">
            <button onClick={handleRelatorioDownload}>Relatório Tecnico</button>
            {/* <Link to='/manual'>Manual</Link> */}
          </div>
        </div>
      </footer>
  )
}